<template>
  <span>
    <a href="#" @click.prevent="() => $bvModal.show('modal-supply-list')"
      ><i class="mx-1 fa fa-lg fa-search search-icon"></i
    ></a>
    <b-modal id="modal-supply-list" scrollable title="Lista de materiales" body-class="p-0">
      <b-input size="sm" placeholder="Escriba para buscar" v-model="search"></b-input>
      <div class="p-0">
        <b-table striped hover :items="filteredItems" :fields="fields"></b-table>
      </div>
    </b-modal>
  </span>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [{ name: "Producto 1", code: 1, price: 100 }]
    }
  },
  data() {
    return {
      search: null,
      fields: [
        {
          key: "code",
          label: "Código",
          sortable: true
        },
        {
          key: "name",
          label: "Descripción",
          sortable: true
        }
      ]
    };
  },
  computed: {
    filteredItems() {
      if (this.search && this.items.length) {
        return this.items.filter((item) => {
          return (
            item.name.toLowerCase().includes(this.search.toLowerCase()) ||
            item.code.toLowerCase().includes(this.search.toLowerCase())
          );
        });
      } else {
        return this.items;
      }
    }
  }
};
</script>

<style>
.search-icon {
  font-size: 0.75rem;
}
</style>
